import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { PlayerSizeDetectionService } from './PlayerSizeDetection.Service';
import { Subscription } from 'rxjs';

/*
* This directive is used to display the controls based on the priority set by the user. PlayerSizeDetectionService keeps track of current priority based on screen size. vgControlDisplay input is the cutoff point for the control to be displayed.
* PlayerSizeDetectionService priority values range from 0-5 where 0 is the lowest priority and 5 is the highest.
*/

@Directive({
	selector: '[vgControlDisplay]',
	standalone: false
})
export class ControlDisplayDirective implements OnInit, OnDestroy {
	@Input() public vgControlDisplay: number;

	public hasView = false;
	private sub: Subscription;

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef,
		private PlayerSizeDetectionService: PlayerSizeDetectionService
	) {}

	public ngOnInit(): void {
		this.sub = this.PlayerSizeDetectionService.playerIconPriority$.subscribe((priority: number) => {
			if (this.vgControlDisplay >= priority && !this.hasView) {
				this.viewContainer.createEmbeddedView(this.templateRef);
				this.hasView = true;
			} else if (this.vgControlDisplay < priority && this.hasView) {
				this.viewContainer.clear();
				this.hasView = false;
			}
		});
	}

	public ngOnDestroy(): void {
		this.sub.unsubscribe();
	}

}
